const onAnimationEnd = (node: HTMLElement, animation: string): Promise<void | string> =>
  // We create a Promise and return it
  new Promise((resolve) => {
    node.classList.add(animation, 'will-change-auto')

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event: AnimationEvent) {
      event.stopPropagation()
      node.classList.remove(animation, 'will-change-auto')
      resolve('Animation ended')
    }

    node.addEventListener('animationend', handleAnimationEnd, { once: true })
  })

export default onAnimationEnd
